import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {
    render() {
        const StockBalanceDetails = this.props.StockBalanceDetails;
        const SearchData = this.props.SearchData;
        const StockBalanceReportInput = this.props.StockBalanceReportInput;
        return (
            <div>
                <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                    <h2><center><u>Stock View Report</u></center></h2>
                    <div>&nbsp;</div>
                    <h3><center>Group: {SearchData.groupName}</center></h3>
                    <h3><center>Factory: {SearchData.factoryName}</center></h3>
                    <h3><center>Item Category: {SearchData.itemCategoryName == undefined ? "All Items" : SearchData.itemCategoryName}</center></h3>
                    <h3><center>Factory Item: {SearchData.factoryItemName == undefined ? 'All Factory Items' : SearchData.factoryItemName}</center></h3>
                    <div>&nbsp;</div>
                    <h2><center>{StockBalanceReportInput.date}</center></h2>
                    <div>
                        <Box minWidth={1050}>
                            <TableContainer style={{ marginLeft: '0rem' }} >
                                <Table aria-label="caption table" size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'center'} style={{ border: "1px solid #ccc" }}>Item Category</TableCell>
                                            <TableCell align={'center'} style={{ border: "1px solid #ccc" }}>Item Code</TableCell>
                                            <TableCell align={'center'} style={{ border: "1px solid #ccc" }}>Item</TableCell>
                                            <TableCell align={'center'} style={{ border: "1px solid #ccc" }}>Available Quantity</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {StockBalanceDetails.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.categoryName}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.itemCode}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.itemName}
                                                </TableCell>
                                                <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.availableQuantity}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>
                    <div>&nbsp;</div>
                    <h3><center>***** End of List *****</center></h3>
                </div>
            </div>
        );

    }

}